export const mutations = {
  setFaqList (state, faqList) {
    state.faqList = faqList
    state.isLoaded = true
  }
}
